import React, { useCallback, useEffect, useMemo, useState } from "react";
import { Panel, PanelBody, PanelHeader } from "../../../util/panel";
import { useParams } from "react-router-dom";
import {
  Button,
  DatePicker,
  Form,
  Icon,
  Input,
  message,
  Modal,
  Radio,
  Select,
  Spin,
  Upload,
} from "antd";
import { Editor } from "react-draft-wysiwyg";
import { EditorState, convertToRaw, ContentState } from "draft-js";
import draftToHtml from "draftjs-to-html";
import htmlToDraft from "html-to-draftjs";
import { SketchPicker } from "react-color";
import { axios, getToken, URL_API } from "../../../../utils";
import { eventRequest } from "../../../../utils/useAxios";
import moment from "moment";
import { useHistory } from "react-router-dom";
import SelectAllType from "../../../../components/SelectAllType";
import dayjs from "dayjs";

const { TextArea } = Input;
const { RangePicker } = DatePicker;
const { confirm } = Modal;

const AddEditChannel = ({ form }) => {
  const { getFieldDecorator } = form;
  const history = useHistory();
  const { eventId } = useParams();
  const [source, setSource] = useState();
  const [eventOnlineList, setEventOnlineList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [displayType, setDisplayType] = useState();
  const [editorState, setEditorState] = useState(EditorState.createEmpty());
  const [isPeriodExpired, setIsPeriodExpired] = useState(false);
  const isEdit = eventId !== "create";
  const _conditionCode = [
    { values: "channel", text: "งานฟรี" },
    { values: "event", text: "งานใช้โค้ด" },
  ];
  const _active = [
    { values: "in-active", text: "ปิด" },
    { values: "active", text: "เปิด" },
  ];
  const conditionCode = useMemo(() => {
    return source && _conditionCode.find((e) => e.values === source);
  }, [source]);
  const setEventOnlineForm = useCallback(
    async (value) => {
      setLoading(true);
      try {
        const res = await eventRequest.get(`/events/${value}`);
        if (res.data) {
          form.setFieldsValue({
            title: res.data.data.EventName,
            prefix_serial: res.data.data.PrefixSerial,
            period_date: [
              moment(res.data.data.StartDate),
              moment(res.data.data.EndDate),
            ],
            thumbnail_display: [
              moment(res.data.data.ReportStartDate),
              moment(res.data.data.ReportEndDate),
            ],
          });
        }
      } catch (error) {
        message.error(error.message);
      } finally {
        setLoading(false);
      }
    },
    [eventOnlineList],
  );
  const normFile = (e) => {
    if (Array.isArray(e)) {
      return e;
    }
    return e && (e?.fileList || []);
  };
  const handleUpload =
    (fieldName) =>
    async ({ file, onSuccess, onError }) => {
      try {
        const res = await uploadCallback(file);
        const url = res.data.link;
        form.setFieldsValue({
          [fieldName]: [
            {
              uid: file.id,
              name: file.file_name,
              status: "done",
              url,
            },
          ],
        });

        onSuccess(res);
      } catch (err) {
        onError(err);
      }
    };
  const beforeUpload = (file) => {
    return new Promise((resolve, reject) => {
      const isValidType =
        file.type === "image/png" ||
        file.type === "image/jpeg" ||
        file.type === "image/jpg";

      if (!isValidType) {
        message.error("รองรับเฉพาะไฟล์ PNG หรือ JPG เท่านั้น");
        return reject();
      }

      const isLt1M = file.size / 1024 / 1024 <= 1;
      if (!isLt1M) {
        message.error("ไฟล์ต้องมีขนาดไม่เกิน 1MB");
        return reject();
      }

      const img = new Image();
      const objectUrl = URL.createObjectURL(file);

      img.onload = () => {
        const { width, height } = img;

        if (width > 1920 || height > 1080) {
          message.error("ขนาดรูปต้องไม่เกิน 1920x1080");
          URL.revokeObjectURL(objectUrl);
          return reject();
        }

        URL.revokeObjectURL(objectUrl);
        resolve(file);
      };

      img.onerror = () => {
        message.error("ไม่สามารถอ่านไฟล์รูปได้");
        reject();
      };

      img.src = objectUrl;
    });
  };
  const uploadCallback = (file) => {
    return new Promise(async (resolve, reject) => {
      try {
        const formData = new FormData();
        formData.append("file", file);
        formData.append("container_name", "web-content");

        const { data } = await axios.post(`/file/upload`, formData, {
          baseURL: URL_API,
          headers: { Authorization: "Bearer " + getToken() },
        });

        resolve({
          data: {
            link: data.data?.azure_url,
            id: data.data.id,
            file_name: data.data.file_name,
          },
        });
      } catch (error) {
        reject(error);
      }
    });
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    form.validateFields(async (err, values) => {
      if (!err) {
        setLoading(true);
        const body = {
          ...values,
          period_start:
            source === "channel"
              ? values.thumbnail_display[0].toDate()
              : values.period_date[0].toDate(),
          period_end:
            source === "channel"
              ? values.thumbnail_display[1].toDate()
              : values.period_date[1].toDate(),
          thumbnail_start: values.thumbnail_display[0].toDate(),
          thumbnail_end: values.thumbnail_display[1].toDate(),
          on_air_start: values.onair_date && values.onair_date[0].toDate(),
          on_air_end: values.onair_date && values.onair_date[1].toDate(),
          bg_color: values.bg_color?.hex,
          prefix_serial: source === "channel" ? "-" : values.prefix_serial,
          cover_url: values.cover_url[0].url,
          bg_url: values.bg_url ? values.bg_url[0].url : null,
        };

        try {
          if (isEdit) {
            await axios.post(`${URL_API}/channel/${eventId}`, body, {
              headers: {
                Authorization: "Bearer " + getToken(),
              },
            });
          } else {
            const res = await axios.post(`${URL_API}/channel`, body, {
              headers: { Authorization: "Bearer " + getToken() },
            });
          }
          history.push(`/events/legacy-channel`);
        } catch (error) {
          message.error(error.message);
        } finally {
          setLoading(false);
        }
      }
    });
  };
  const loadEventOnline = useCallback(async () => {
    setLoading(true);
    try {
      const masterChannel = await axios.get(`${URL_API}/channel`, {
        headers: {
          Authorization: "Bearer " + getToken(),
        },
      });
      const event = await eventRequest.get(
        `/events/active?eventType=ONLINE`,
        {},
      );
      const masterIdSet = new Set(
        masterChannel.data.data.map((item) => item.event_id),
      );
      const currentEventId = form.getFieldValue("event_id");
      const eventNotCreate = event.data.data.filter(
        (item) => !masterIdSet.has(item.Id) || item.Id === currentEventId,
      );

      setEventOnlineList(eventNotCreate);
    } catch (error) {
      message.error(error.message);
    } finally {
      setLoading(false);
    }
  }, []);
  const loadChannelData = useCallback(async () => {
    setLoading(true);
    try {
      const res = await axios.get(`${URL_API}/channel/${eventId}`, {
        headers: {
          Authorization: "Bearer " + getToken(),
        },
      });
      const masterChannel = res.data.data;
      setSource(masterChannel.source);
      setDisplayType(masterChannel.display_type);
      form.setFieldsValue({
        source: masterChannel.source,
        bg_url: [
          {
            uid: "edit-bg",
            name: "edit-bg",
            status: "done",
            url: masterChannel.bg_url,
          },
        ],
        bg_color: masterChannel.bg_color || "",
        description: masterChannel.description,
        display_type: masterChannel.display_type,
        event_id: masterChannel.event_id,
        prefix_serial: masterChannel.prefix_serial,
        embled_chat: masterChannel.embled_chat,
        embled_video: masterChannel.embled_video,
        event_type: masterChannel.event_type,
        cover_url: [
          {
            uid: "edit-image",
            name: "edit-image",
            status: "done",
            url: masterChannel.cover_url,
          },
        ],
        period_date: [
          moment(masterChannel.period_start),
          moment(masterChannel.period_end),
        ],
        onair_date: [
          moment(masterChannel.on_air_start),
          moment(masterChannel.on_air_end),
        ],
        prefix_serial: masterChannel.prefix_serial,
        status: masterChannel.status,
        title: masterChannel.title,
        thumbnail_display: [
          moment(masterChannel.thumbnail_start),
          moment(masterChannel.thumbnail_end),
        ],
      });
      if (masterChannel.description) {
        const contentBlock = htmlToDraft(masterChannel.description);
        const contentState = ContentState.createFromBlockArray(
          contentBlock.contentBlocks,
        );
        const editorState = EditorState.createWithContent(contentState);

        setEditorState(editorState);
      }
      if (masterChannel.thumbnail_end) {
        const end = moment(masterChannel.thumbnail_end);

        if (!end) return setIsPeriodExpired(false);

        const now = dayjs();
        setIsPeriodExpired(now.isAfter(dayjs(end)));
      }
    } catch (error) {
      message.error(error.message);
    } finally {
      setLoading(false);
    }
  }, []);
  useEffect(() => {
    if (isEdit) loadChannelData();
    loadEventOnline();
  }, [loadEventOnline, loadChannelData, isEdit]);
  return (
    <Panel>
      <PanelHeader>{isEdit ? "Edit Channel" : "Create Channel"}</PanelHeader>
      <PanelBody>
        <Spin spinning={loading}>
          <Form colon={false} onSubmit={handleSubmit}>
            {getFieldDecorator("prefix_serial")(<Input type="hidden" />)}
            <Form.Item>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 10,
                  marginBottom: 0,
                }}
              >
                <span>แหล่งที่มา</span>
                {getFieldDecorator("source", {
                  rules: [
                    {
                      required: true,
                      message: "กรุณากรอกเลือกแหล่งที่มา",
                    },
                  ],
                })(
                  <Radio.Group
                    onChange={(e) => {
                      const value = e.target.value;
                      const prefix = form.getFieldValue("prefix_serial");
                      if (value === "channel" && prefix) {
                        confirm({
                          title: "แหล่งที่มาไม่ถูกต้อง",
                          content:
                            "การเปลี่ยนแหล่งที่มาเป็น channel จะทำให้ข้อมูลบางส่วนที่ถูกดึงมาจาก event online จะถูกลบออกไป",
                          onOk() {
                            setSource(value);
                            form.setFieldsValue({
                              Source: value,
                              title: null,
                              prefix_serial: null,
                              period_date: null,
                              event_id: null,
                            });
                          },
                          onCancel() {
                            form.setFieldsValue({ Source: source });
                          },
                        });
                        return;
                      }
                      setSource(value);
                    }}
                    disabled={isEdit}
                  >
                    <Radio value="channel">Channel</Radio>
                    <Radio value="event">Event Online</Radio>
                  </Radio.Group>,
                )}
              </div>
            </Form.Item>
            <div style={{ display: "flex", gap: "20px" }}>
              <Form.Item>
                {getFieldDecorator("cover_url", {
                  valuePropName: "fileList",
                  getValueFromEvent: normFile,
                  rules: [{ required: true, message: "กรุณากรอกข้อมูล" }],
                })(
                  <Upload
                    showUploadList={false}
                    name="file"
                    listType="picture"
                    style={{
                      width: "100px",
                      height: "100px",
                    }}
                    customRequest={handleUpload("cover_url")}
                    beforeUpload={beforeUpload}
                  >
                    <div
                      style={{
                        width: "100px",
                        height: "100px",
                        border: "2px dotted #d9d9d9",
                        borderRadius: "10px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        overflow: "hidden",
                      }}
                    >
                      {form.getFieldValue("cover_url")?.[0]?.url ? (
                        <img
                          src={form.getFieldValue("cover_url")?.[0]?.url}
                          alt="preview"
                          style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                          }}
                        />
                      ) : (
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            gap: "10px",
                          }}
                        >
                          <Icon type="upload" />
                          <span>Upload</span>
                        </div>
                      )}
                    </div>
                  </Upload>,
                )}
              </Form.Item>
              <div style={{ display: "flex", gap: 10, width: "100%" }}>
                <Form.Item
                  label="ชื่อโปรเจค"
                  style={{
                    width: "100%",
                    display: source === "channel" || !source ? "block" : "none",
                  }}
                >
                  {getFieldDecorator("title", {
                    rules: [{ required: true, message: "กรุณากรอกชื่อโปรเจค" }],
                  })(<Input placeholder="ชื่อโปรเจค" />)}
                </Form.Item>
                {source !== "channel" && (
                  <Form.Item
                    label="ชื่อโปรเจค"
                    style={{
                      width: "100%",
                      display:
                        source && source !== "Channel" ? "block" : "none",
                    }}
                  >
                    {getFieldDecorator("event_id", {
                      rules: [{ required: true, message: "กรุณาเลือก Event" }],
                    })(
                      <Select
                        placeholder="Event Online"
                        onChange={(value) => setEventOnlineForm(value)}
                        disabled={isEdit}
                      >
                        {eventOnlineList.map((e) => (
                          <Select.Option key={e.Id} value={e.Id}>
                            {e.EventName}
                          </Select.Option>
                        ))}
                      </Select>,
                    )}
                  </Form.Item>
                )}
                <Form.Item label="Condition Code" style={{ width: "100%" }}>
                  <div>{conditionCode?.text}</div>
                </Form.Item>
              </div>
            </div>
            <Form.Item label="Event Type" style={{ flex: 1 }}>
              {getFieldDecorator("event_type", {
                rules: [
                  { required: true, message: "กรุณากรอกเลือก Event Type" },
                ],
              })(
                <SelectAllType
                  process_type="channel_event_type"
                  placeholder="Event Type"
                  className="w-100"
                  allowClear
                />,
              )}
            </Form.Item>
            <Form.Item label="Description" style={{ flex: 1 }}>
              <Editor
                editorState={editorState}
                toolbar={{
                  image: {
                    urlEnabled: true,
                    uploadEnabled: true,
                    uploadCallback: uploadCallback,
                    previewImage: true,
                  },
                }}
                editorClassName="border"
                onEditorStateChange={(state) => {
                  setEditorState(state);

                  const raw = convertToRaw(state.getCurrentContent());
                  const html = draftToHtml(raw);

                  form.setFieldsValue({
                    description: html,
                  });
                }}
              />
            </Form.Item>
            <Form.Item style={{ display: "none" }}>
              {getFieldDecorator("description")(<Input />)}
            </Form.Item>
            <Form.Item label="Embled Video" style={{ flex: 1 }}>
              {getFieldDecorator("embled_video", {
                rules: [
                  { required: true, message: "กรุณากรอกไส่ Embled Video" },
                ],
              })(<TextArea rows={2} />)}
            </Form.Item>
            <Form.Item label="Embled Chat" style={{ flex: 1 }}>
              {getFieldDecorator("embled_chat")(<TextArea rows={2} />)}
            </Form.Item>
            <p
              style={{
                fontSize: "24px",
                fontWeight: "700",
              }}
            >
              Setting Video
            </p>
            <div style={{ width: "100%", border: "1px solid #d9d9d9" }} />
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(5, 1fr)",
                gap: "10px",
              }}
            >
              <Form.Item label="การแสดงผล thumbnail" style={{ flex: 1 }}>
                {getFieldDecorator("status", {
                  initialValue: "in-active",
                })(
                  <Select
                    className="w-100"
                    placeholder="Event Type"
                    disabled={isEdit && isPeriodExpired}
                  >
                    {_active.map((e, i) => (
                      <Select.Option key={i} value={e.values}>
                        {e.text}
                      </Select.Option>
                    ))}
                  </Select>,
                )}
              </Form.Item>
              <Form.Item
                label="ระยะเวลาแสดงผล thumbnail"
                style={{ gridColumn: "span 2", flex: 1 }}
              >
                {getFieldDecorator("thumbnail_display", {
                  rules: [{ required: true, message: "กรุณากรอกข้อมูล" }],
                })(
                  <RangePicker
                    style={{ width: "100%" }}
                    showTime={{ format: "HH:mm" }}
                    format="DD/MM/YYYY HH:mm"
                    disabled={source !== "channel"}
                    onChange={(changed) => {
                      if (changed) {
                        const end = changed?.[1];

                        if (!end) return setIsPeriodExpired(false);

                        const now = dayjs();
                        const isExpired = now.isAfter(dayjs(end));

                        setIsPeriodExpired(isExpired);
                        if (isExpired) {
                          form.setFieldsValue({
                            status: "in-active",
                          });
                        }
                      }
                    }}
                  />,
                )}
              </Form.Item>
              {source === "event" && (
                <Form.Item
                  label="Option public period Start-End date"
                  style={{ gridColumn: "span 2", flex: 1 }}
                >
                  {getFieldDecorator("period_date", {
                    rules: [{ required: true, message: "กรุณากรอกข้อมูล" }],
                  })(
                    <RangePicker
                      style={{ width: "100%" }}
                      showTime={{ format: "HH:mm" }}
                      format="DD/MM/YYYY HH:mm"
                      disabled={source !== "channel"}
                    />,
                  )}
                </Form.Item>
              )}
            </div>
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(2, 1fr)",
                gap: "10px",
              }}
            >
              <Form.Item label="Type">
                {getFieldDecorator("display_type", {
                  rules: [{ required: true, message: "กรุณากรอกข้อมูล" }],
                })(
                  <SelectAllType
                    process_type="channel_display_type"
                    placeholder="Type"
                    className="w-100"
                    onChange={(e) => setDisplayType(e)}
                    allowClear
                  />,
                )}
              </Form.Item>
              {displayType === "stream" && (
                <>
                  <Form.Item label="Onair Date" style={{ flex: 1 }}>
                    {getFieldDecorator("onair_date", {
                      rules: [{ required: true, message: "กรุณากรอกข้อมูล" }],
                    })(
                      <RangePicker
                        style={{ width: "100%" }}
                        showTime={{ format: "HH:mm" }}
                        format="DD/MM/YYYY HH:mm"
                        placeholder={["Start Time", "End Time"]}
                      />,
                    )}
                  </Form.Item>
                </>
              )}
            </div>
            <p
              style={{
                fontSize: "24px",
                fontWeight: "700",
              }}
            >
              Setting Background
            </p>
            <div style={{ width: "100%", border: "1px solid #d9d9d9" }} />
            <div
              style={{ display: "grid", gridTemplateColumns: "repeat(2, 1fr)" }}
            >
              <Form.Item>
                {getFieldDecorator("bg_color")(
                  <SketchPicker
                    color={form.getFieldValue("bg_color") || ""}
                    onChange={(c) => {
                      form.setFieldsValue({ bg_color: c?.hex });
                    }}
                    disableAlpha
                  />,
                )}
              </Form.Item>
              <Form.Item label="Background Image">
                {getFieldDecorator("bg_url", {
                  valuePropName: "fileList",
                  getValueFromEvent: normFile,
                })(
                  <Upload
                    name="file"
                    showUploadList={false}
                    customRequest={handleUpload("bg_url")}
                  >
                    <div
                      style={{
                        width: "100px",
                        height: "100px",
                        border: "2px dotted #d9d9d9",
                        borderRadius: "10px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        overflow: "hidden",
                      }}
                    >
                      {form.getFieldValue("bg_url")?.[0]?.url ? (
                        <img
                          src={form.getFieldValue("bg_url")[0].url}
                          alt="preview"
                          style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                          }}
                        />
                      ) : (
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            gap: "10px",
                          }}
                        >
                          <Icon type="upload" />
                          <span>Upload</span>
                        </div>
                      )}
                    </div>
                  </Upload>,
                )}
              </Form.Item>
            </div>
            <div
              style={{
                width: "100%",
                border: "1px solid #d9d9d9",
                marginBottom: "10px",
              }}
            />
            <div style={{ display: "flex", gap: "15px" }}>
              <Form.Item>
                <Button onClick={() => history.push(`/events/legacy-channel`)}>
                  cancle
                </Button>
              </Form.Item>
              <Form.Item>
                <Button type="primary" htmlType="submit">
                  Save
                </Button>
              </Form.Item>
            </div>
          </Form>
        </Spin>
      </PanelBody>
    </Panel>
  );
};

export default Form.create()(AddEditChannel);
